export default __webpack_public_path__ + "static/media/fpa41000.eb204c32.png";